Vue.component('faction', {
    template: templates.adminFaction,
    data() {
      return {
        model: {
            edit: false,
            faction: {
                id: null,
                name: null,
                description: null,
                image: null
            },
            factions:{},
            factionMembers:[],
            expandedRow: '',
            searchTerm: '',
        }
      }
    },
    watch: {
      'model.faction.image': function(newImage) {
        this.refreshImage(); 
      }
    },
    computed: {
      filteredMembers() {
        const c = this;
        const searchTermLower = c.model.searchTerm.toLowerCase();

        // console.log(searchTermLower);
        return c.model.factionMembers.filter(member => {
          return (
            (member.twitchId && member.twitchId.includes(c.model.searchTerm)) ||
            (member.twitchDisplayName && member.twitchDisplayName.includes(c.model.searchTerm))
          );
        });
      },
    },
    mounted() {
        const c = this;
        c.get();
        c.connect();

        c.$root.$on('remove-existing-image', data => {
          c.removeCurrentFile(data);
        })
    },
    methods: {
        connect() {
            const c = this;
            c.ws = new WebSocket(utils.getWsUrl());
        
            c.ws.onmessage = (event) => {
        
                const messageData = event.data;
        
                try {
        
                const parsedData = JSON.parse(messageData);
            
        
                } catch (error) {
                console.error('Error parsing message data:', error);
                }
            
            };
        
            c.ws.onopen = () => {
                console.log('WebSocket connection established');
            };
        
            c.ws.onclose = () => {
                console.log('WebSocket connection closed');
            };
        },
        get(){
            const c = this;
            let data = {};

            factionService.get()
            .then(function (response) {
            for (let d of response.data) {
                // Initialize image and video as arrays
                // Check if image exists - try to preserve existing structure
                if (d.image) {
                    d.image = Array.isArray(d.image) ? d.image : [d.image];
                } else {
                    // Try default image path
                    d.image = [`${d.id}.png`];
                }
                
                // Only set video if it exists, don't create default paths
                if (d.video) {
                    d.video = Array.isArray(d.video) ? d.video : [d.video];
                } else {
                    // Set to empty array if no video
                    d.video = [];
                }
                
                // Track which videos/images actually exist
                d.validVideos = [];
                d.validImages = [];
                
                data[`${d.id}`] = d;
            }
            c.model.factions = data;
            // Check for existing media files after data is loaded
            c.validateMediaFiles();
            })
            .catch(function (error) {
            //console.log(error);
            });

         },
         add(){
            const c = this;
            c.model.edit = true;
         },
         edit(id){
            const c = this;

            console.log(id)
            let data = c.model.factions[`${id}`];

            if (id == c.model.faction.id) {
                c.model.edit = false;
            } else {
                c.model.edit = true;
            }
            
            c.model.faction = {
                id: id,
                name: data.name,
                description: data.description,
                image: Array.isArray(data.image) ? data.image : (data.image ? [data.image] : [`${data.id}.png`]),
                video: Array.isArray(data.video) ? data.video : (data.video ? [data.video] : []),
            }
            
         },
         save(){
            const c = this;

            const data = c.model.faction;

       
            if (!data.name) {
              utils.alert.error('name is required');
              return;
            }

            if (!data.description) {
              utils.alert.error('description is required');
              return;
            }
            console.log(data)
            factionService.save(data)
            .then(function (response) {
              c.reset();
              c.get();
    
              // c.ws.send(JSON.stringify(messageData));
              utils.alert.success('Saved!');
              
            })
            .catch(function (error) {
              utils.alert.error('Failed to save.');
            });

         },
         upload() {
            const c = this;
      
            let data = new FormData();
            data.append('file', this.$refs.file.files[0]);
            data.append('type', 'faction');
            data.append('id', c.model.faction.id);
      
            uploadService.uploadFile(data)
              .then(function (response) {
                utils.alert.success('File uploaded!');
              })
              .catch(function (error) {
                utils.alert.error('File failed to uploaded.');
              });
          },
         reset(){
            const c = this;

            c.model.edit = false

            c.model.faction = {
                id: null,
                name: null,
                description: null,
                image: null,
                video: null,
            }
         },
         toggleDetails(index){
          const c = this;

          c.model.expandedRow = c.model.expandedRow === index ? null : index;

          console.log(index)

          if(c.model.expandedRow != null){
            c.model.factionMembers = [];
            factionService.getFaction(index)
            .then(function(response){
              c.getTwitchInfo(response.data)
            })
            .catch(function(error){
              console.log(error)
            })
          }
         
        },
        getTwitchInfo(data) {
          const c = this;
    
          const twitchIds = data.map(item => ({ twitchId: item.twitchId }));

          // Call the Twitch API to get user data
          twitchAPI.getUsersById(twitchIds, function(userData) {
              for (let d of userData) {
                  // Create a user object from the API response
                  let user = {
                      twitchId: d.id,
                      twitchDisplayName: d.display_name,
                      twitchProfileImage: d.profile_image_url
                  };
          
                  // Find the corresponding entry in the original data
                  const match = data.find(item => item.twitchId === user.twitchId);
                  
                  // If a match is found, push the user object into factionMembers
                  if (match) {
                      // Optionally, you can merge user data with the match
                      const factionMember = {
                          ...match, // Spread the original match data
                          twitchDisplayName: user.twitchDisplayName,
                          twitchProfileImage: user.twitchProfileImage
                      };
                      c.model.factionMembers.push(factionMember);
                  }
              }
          });
          
        },
        removeUser(id, index, username, factionName){
          const c = this;
          var result = confirm(
            `Are you sure you want to remove ${username} this user from ${factionName}?`
          );
          if(result){
            c.model.expandedRow = null;
            factionService.userRemove(id).then(function(response){
              if(response.data.status === 200){
                console.log('dito muna')
                console.log(index)
                console.log('jan naman')
                c.toggleDetails(index);
               
              }
              else{
                utils.alert.error(response.data.message)
              }
            })
            .catch(function(error){
              console.log(error)
            })
          }
       
        },
        handleFactionImageUpload(data){
          const c = this;
          const fileExtension = data.filename ? data.filename.split('.').pop().toLowerCase() : 'png';
          const isVideo = ['webm', 'mp4', 'mov', 'avi'].includes(fileExtension);
          
          if (isVideo) {
            // Handle video upload
            if (!c.model.faction.video) {
              c.model.faction.video = [];
            }
            if (!Array.isArray(c.model.faction.video)) {
              c.model.faction.video = [c.model.faction.video];
            }
            const videoFileName = `${data.id}.${fileExtension}`;
            if (!c.model.faction.video.includes(videoFileName)) {
              c.model.faction.video.push(videoFileName);
            }
            
            // Update factions object
            if (!c.model.factions[`${data.id}`].video) {
              c.model.factions[`${data.id}`].video = [];
            }
            if (!Array.isArray(c.model.factions[`${data.id}`].video)) {
              c.model.factions[`${data.id}`].video = [c.model.factions[`${data.id}`].video];
            }
            if (!c.model.factions[`${data.id}`].video.includes(videoFileName)) {
              c.model.factions[`${data.id}`].video.push(videoFileName);
            }
          } else {
            // Handle image upload
            if (!c.model.faction.image) {
              c.model.faction.image = [];
            }
            if (!Array.isArray(c.model.faction.image)) {
              c.model.faction.image = [c.model.faction.image];
            }
            const imageFileName = `${data.id}.${fileExtension}`;
            if (!c.model.faction.image.includes(imageFileName)) {
              c.model.faction.image.push(imageFileName);
            }
            
            // Update factions object
            if (!c.model.factions[`${data.id}`].image) {
              c.model.factions[`${data.id}`].image = [];
            }
            if (!Array.isArray(c.model.factions[`${data.id}`].image)) {
              c.model.factions[`${data.id}`].image = [c.model.factions[`${data.id}`].image];
            }
            if (!c.model.factions[`${data.id}`].image.includes(imageFileName)) {
              c.model.factions[`${data.id}`].image.push(imageFileName);
            }
          }
          c.refreshImage();
        },
        refreshImage() {
          const c = this;
          const imageUrl = `${c.getFactionUrl()}${c.model.faction.image}`;
          
          c.checkImageExists(imageUrl).then(exists => {
            if (!exists) {
              c.model.faction.image = null; 
              c.model.factions[`${c.model.faction.id}`].image = null
            }
          });
        },
        checkImageExists(url) {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
          });
        },
        getFactionUrl(){
          const c = this;
          const url = `${root}/images/faction/`;
          return url;
        },
        getFactionImageUrl(factionId, imageName) {
          const c = this;
          if (!imageName) return '';
          // If imageName already contains full path, return as is
          if (imageName.startsWith('http') || imageName.startsWith('/')) {
            return imageName;
          }
          return `${root}/images/faction/${imageName}`;
        },
        getFactionVideoUrl(factionId, videoName) {
          const c = this;
          if (!videoName || typeof videoName !== 'string' || videoName.trim() === '') {
            return '';
          }
          // If videoName already contains full path, return as is
          if (videoName.startsWith('http') || videoName.startsWith('/')) {
            return videoName;
          }
          // Check if this is a valid video file (has extension)
          if (!videoName.includes('.')) {
            return '';
          }
          // Don't create URL for obviously invalid/default video names
          const videoNameLower = videoName.toLowerCase();
          if (videoNameLower === 'null' || videoNameLower === 'undefined' || videoNameLower === 'false') {
            return '';
          }
          return `${root}/videos/faction/${videoName}`;
        },
        hasValidVideo(faction) {
          const c = this;
          if (!faction) return false;
          if (!faction.video) return false;
          if (Array.isArray(faction.video)) {
            return faction.video.length > 0 && faction.video.some(vid => {
              if (!vid || typeof vid !== 'string') return false;
              const trimmed = vid.trim();
              return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined' && trimmed.includes('.');
            });
          }
          if (typeof faction.video !== 'string') return false;
          const trimmed = faction.video.trim();
          return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined' && trimmed.includes('.');
        },
        handleImageError(event, factionId, type) {
          const c = this;
          // Hide broken image
          if (event.target) {
            event.target.style.display = 'none';
          }
          // Optionally remove from array
          const faction = c.model.factions[`${factionId}`];
          if (faction && faction.image) {
            if (Array.isArray(faction.image)) {
              const index = faction.image.findIndex(img => {
                const imgUrl = c.getFactionImageUrl(factionId, img);
                return event.target.src === imgUrl || event.target.src.includes(img);
              });
              if (index !== -1) {
                faction.image.splice(index, 1);
              }
            } else {
              faction.image = null;
            }
          }
        },
        handleVideoError(event, factionId, type) {
          const c = this;
          // Hide broken video and show placeholder
          if (event.target) {
            event.target.style.display = 'none';
            // Find or create placeholder element
            const container = event.target.parentNode;
            let placeholder = container.querySelector('.video-placeholder, .video-placeholder-large');
            if (!placeholder) {
              placeholder = document.createElement('div');
              placeholder.className = container.classList.contains('video-container-large') ? 'video-placeholder-large' : 'video-placeholder';
              placeholder.innerHTML = '<i class="bi-play-circle"></i><span>Video unavailable</span>';
              container.appendChild(placeholder);
            }
            placeholder.style.display = 'flex';
          }
          // Remove from valid videos array
          const faction = c.model.factions[`${factionId}`];
          if (faction && faction.validVideos) {
            const failedUrl = event.target.src;
            faction.validVideos = faction.validVideos.filter(vid => {
              const vidUrl = c.getFactionVideoUrl(factionId, vid);
              return vidUrl !== failedUrl && !failedUrl.includes(vid);
            });
          }
        },
        handleVideoLoaded(event, factionId, videoName) {
          const c = this;
          // Video loaded successfully, add to valid videos
          const faction = c.model.factions[`${factionId}`];
          if (faction) {
            if (!faction.validVideos) {
              faction.validVideos = [];
            }
            if (!faction.validVideos.includes(videoName)) {
              faction.validVideos.push(videoName);
            }
            // Hide placeholder if it exists
            const container = event.target.parentNode;
            const placeholder = container.querySelector('.video-placeholder, .video-placeholder-large');
            if (placeholder) {
              placeholder.style.display = 'none';
            }
          }
        },
        validateMediaFiles() {
          const c = this;
          // This method can be used to pre-validate media files if needed
          // For now, we'll rely on error handlers
        },
        videoExists(factionId, videoName) {
          const c = this;
          if (!videoName) return false;
          const faction = c.model.factions[`${factionId}`];
          if (!faction || !faction.validVideos) return true; // Assume exists if not validated yet
          return faction.validVideos.includes(videoName);
        },
        removeCurrentFile(data){
          const c = this;

          const id = c.model.faction.id
          uploadService.deleteFile('faction', id, data.image)
          .then(function (response) {

            c.model.faction.image = null;
            utils.alert.success('File Removed!');
          })
          .catch(function (error) {
            utils.alert.error(error);
          });
        },
    }
  });

    